import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '@laspalmas-identity/server';

async function csrfFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const method = init?.method?.toUpperCase() ?? 'GET';
  const headers = new Headers(init?.headers);
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const response = await fetch('/api/csrf', { credentials: 'include' });
    if (!response.ok) throw new Error('Non se puido preparar a solicitude segura');
    const body = await response.json() as { token: string };
    headers.set('csrf-token', body.token);
  }
  return fetch(input, { ...init, headers, credentials: 'include' });
}

export const trpc = createTRPCClient<AppRouter>({
  links: [httpBatchLink({ url: '/trpc', fetch: (url, options) => csrfFetch(url, options as RequestInit) })],
});

export type IdentityTrpcClient = typeof trpc;
